import { render, staticRenderFns } from "./FormEquation.vue?vue&type=template&id=12ae8546&scoped=true&"
import script from "./FormEquation.vue?vue&type=script&lang=js&"
export * from "./FormEquation.vue?vue&type=script&lang=js&"
import style0 from "./FormEquation.vue?vue&type=style&index=0&id=12ae8546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ae8546",
  null
  
)

export default component.exports